export default __webpack_public_path__ + "barcode_guide.0738f6b71059b746bafbd1838ec5ccc7.svg";